// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"tasks_tabContainer__3FG8M","addressBox":"tasks_addressBox__2BrB8","needToKnowMain":"tasks_needToKnowMain__LG_yJ"};